import lazyWithRetry from '@shared/lib/lazyWithRetry';
import Loadable from '@components/Loadable/Loadable';

const CaseCreatePage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/create.tsx'))
);
const CaseEditPage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/edit.tsx'))
);
const CaseViewPage = Loadable(
  lazyWithRetry(() => import('@pages/CasePage/view.tsx'))
);

const CaseChildRoutes = {
  path: 'cases',
  children: [
    {
      path: 'create',
      element: <CaseCreatePage />,
    },
    {
      path: 'edit/:case_id',
      element: <CaseEditPage />,
    },
    {
      path: 'view/:case_id',
      element: <CaseViewPage />,
    },
  ],
};

export default CaseChildRoutes;
